module.exports = "/_next/static/images/e224f4cbac4b21d01b3ac2fa1fa93599-cajitas-left-desktop.jpg.webp";